<template>
  <div ref="cell" class="grid-view__cell active">
    <div v-if="value" class="field-last-modified-by">
      <div class="field-last-modified-by__name background-color--light-gray">
        <span class="field-last-modified-by__name-text">
          <SearchHighlightedText
            :text="getCollaboratorName(value)"
            :search-term="searchTerm"
          />
        </span>
      </div>
      <div class="field-last-modified-by__initials">
        {{ getCollaboratorNameInitials(value) }}
      </div>
    </div>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import collaboratorName from '@baserow/modules/database/mixins/collaboratorName'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  components: { SearchHighlightedText },
  mixins: [gridField, collaboratorName],
}
</script>
